module.exports = __webpack_public_path__ + "static/img/5-1.4a95cc9d.png";